import { Dumbbell } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

/**
 * Empty state shown when the miniapp opens without widget params — matches the HqO
 * concentric-rings pattern (see communications-admin table/builder empty states): faint
 * grey rings radiating from a centered icon chip, with a title + description.
 */
export const MindbodyEmptyState = (): JSX.Element => (
  <div data-testid="mindbody-no-widget" className="grid place-items-center p-5">
    <div className="relative size-[480px] overflow-hidden">
      <div className="absolute left-1/2 top-1/2 size-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-15" />
      <div className="absolute left-1/2 top-1/2 size-[416px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-25" />
      <div className="absolute left-1/2 top-1/2 size-[352px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-35" />
      <div className="absolute left-1/2 top-1/2 size-[288px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-45" />
      <div className="absolute left-1/2 top-1/2 size-[224px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-55" />
      <div className="absolute left-1/2 top-1/2 size-[160px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-65" />
      <div className="absolute left-1/2 top-1/2 size-[96px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-system-grey-medium opacity-75" />

      <div className="absolute left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-[28px] flex-col items-center justify-center gap-5">
        <div className="grid size-[56px] place-items-center rounded-xl border border-border-border-secondary bg-background shadow-xs">
          <Dumbbell className="size-[24px] text-foreground" />
        </div>
        <div className="flex flex-col items-center justify-center gap-2 text-center">
          <div className="text-xl font-semibold leading-7">
            <FormattedMessage id="mindbody.noWidget" />
          </div>
          <div className="w-[352px] text-sm leading-6 text-text-tertiary">
            <FormattedMessage id="mindbody.noWidgetDescription" />
          </div>
        </div>
      </div>
    </div>
  </div>
);
